export default __webpack_public_path__ + "static/media/pof-proofOfResidence.a560ee8d.png";